<template>
  <div class="MemberList" v-title data-title="水产圈子用户管理">
    <div class="pt5 pl7 text-left">
      <van-button size="small" class="btn-common" plain="" type="info" @click="back">返回</van-button>
      <span v-if="fromUserEdit" class="text-left fc-info pl8 font-bold fc-primary-dark">
        报价商：{{ returnParams.webStoreName || '未知' }}，圈子用户：{{ returnParams.miniMemberName || "未绑定" }}
      </span>
    </div>

    <div class="row align-items-center pr7">
      <div class="row align-items-center pt2">
        <div class="pl5 pr1">用户状态</div>
        <select placeholder="请选择用户状态" v-model="params.status">
          <option v-for="option in statusOptions" :key="option.value" :value="option.value">
            {{option.text}}
          </option>
        </select>
      </div>
      <div class="row align-items-center pt2">
        <div class="pl5 pr1">认证状态</div>
        <select placeholder="请选择认证状态" v-model="params.accreditationStatus">
          <option v-for="option in accreditationStatusOptions" :key="option.value" :value="option.value">
            {{option.text}}
          </option>
        </select>
      </div>
      <div class="row align-items-center pt2">
        <div class="pl5 pr1">个人信息</div>
        <select placeholder="信息是否完善" v-model="params.improved">
          <option value="">全部</option>
          <option :value="1">完善</option>
          <option :value="0">未完善</option>
        </select>
      </div>
      <div class="row align-items-center pt2">
        <div class="pl5 pr1">买卖信息</div>
        <select placeholder="有无买卖信息" v-model="params.postedRequirements">
          <option value="">全部</option>
          <option :value="true">有</option>
          <option :value="false">无</option>
        </select>
      </div>
      <div class="row align-items-center pt2">
        <div class="pl9 pr1">关键字</div>
        <input class="keywords-input" v-model="params.keywords" placeholder="手机、昵称、微信号"/>
      </div>
      <!-- <div class="row align-items-center pt2">
        <div class="pl2 pr1">注册时间</div>
        <input class="date-select" v-model="params.regStartDate" placeholder="yyyy-mm-dd" />-<input class="date-select" v-model="params.regEndDate" placeholder="yyyy-mm-dd" />
      </div> -->
      <div class="flex-1"></div>
      <div class="pt2 pl2">
        <van-button type="info" size="small" class="button"
                @click="getData()">查 询</van-button>
      </div>
    </div>
    <div class="row align-items-center pr7 pt5 pl3">
      <div class="font-bold flex-1 text-left">共{{(total||0)}}用户</div>
    </div>
    <van-list
      v-model="loading"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      :finished="finished"
      :finished-text="records.length > 10 ? '没有更多了' :''"
      @load="loadMore"
    >
      <div class="pt5 text-left">
        <div class="row align-items-baseline line pl1 font-bold">
          <div class="col-3 pr1 pt1 pb1">手机号</div>
          <div class="col-4 pr1 pt1 pb1">昵称/用户ID</div>
          <div class="col-3 pr1 pt1 pb1">微信号</div>
          <div class="col-3 pr1 pt1 pb1">身份</div>
          <div class="col-2 pr1 pt1 pb1 text-center">买卖信息</div>
          <div class="col-2 pr1 pt1 pb1">用户状态</div>
          <div class="col-3 pr1 pt1 pb1">认证状态</div>
          <div class="col-4 pr1 pt1 pb1">操作</div>
        </div>
        <div class="row align-items-baseline line pl1" :title="`注册时间：${item.createTime}`"
          v-for="(item) in records"
          :key="item.memberId">
          <div class="col-3 pr1 pt1 pb1">{{item.phoneNumber}}</div>
          <div class="col-4 pr1 pt1 pb1">{{item.nickname||item.memberId}}</div>
          <div class="col-3 pr1 pt1 pb1">{{item.wechatNo}}</div>
          <div class="col-3 pr1 pt1 pb1">{{item.identityName}}</div>
          <div class="col-2 pr1 pt1 pb1 text-center">{{item.postedRequirements ? '有' : '无'}}</div>
          <div class="col-2 pr1 pt1 pb1">{{item.statusName}}</div>
          <div class="col-3 pr1 pt1 pb1">{{item.accreditationStatusName}}</div>
          <div class="col-4 pr1 pt1 pb1">
            <template v-if="fromUserEdit">
              <van-button size="mini" class="fc-primary" @click="selectMember(item)">选择</van-button>
            </template>
            <template v-else>
              <!-- <van-button size="mini" class="fc-primary" @click="editItem(item)">编辑</van-button> -->
              <van-button v-if="(item.status != STATUS.NORMAL)" size="mini" class="fc-light" @click="unbanItem(item)">恢复</van-button>
              <van-button v-else size="mini" class="fc-primary-dark" @click="deleteItem(item)">拉黑</van-button>
              <van-button :disabled="(item.accreditationStatus == STATUS.APPROVED)" size="mini" class="fc-success" @click="approveItem(item)">通过</van-button>
              <van-button :disabled="(item.accreditationStatus == STATUS.REFUSED)" size="mini" class="fc-red" @click="refuseItem(item)">拒绝</van-button>
            </template>
          </div>
        </div>
      </div>
    </van-list>

    <van-popup v-model="detailShow">内容</van-popup>

  </div>
</template>

<script>
import Vue from 'vue';
import {
  sendRequest, getConnectionsList, changeMemberAccreditationStatus, changeMemberStatus,
} from '../../network/NetworkAccessor';
import storage from '../../uitls/cacheUtil';
import config from '../../config';

/**
 * 1 未认证
 * 2 已认证待审核
 * 3 审核通过
 * 4 审核失败
 */
// 1 正常
// 2 已拉黑
const STATUS = {
  NORMAL: 1,
  DELETE: 0,
  UNVERIFIED: 1,
  VERIFIED: 2,
  APPROVED: 3,
  REFUSED: 4,
};

const statusName = {
  [STATUS.NORMAL]: '正常',
  [STATUS.DELETE]: '已拉黑',
};
const accreditationStatusName = {
  [STATUS.UNVERIFIED]: '未认证',
  [STATUS.VERIFIED]: '已认证未审核',
  [STATUS.REFUSED]: '审核不通过',
  [STATUS.APPROVED]: '审核通过',
};

export default Vue.extend({
  name: 'MemberList',
  components: {},
  data() {
    const statusOptions = Object.entries(statusName).map(([value, text]) => ({
      value,
      text,
    }));
    statusOptions.unshift({ value: '', text: '全部' });

    const accreditationStatusOptions = Object.entries(accreditationStatusName).map(([value, text]) => ({
      value,
      text,
    }));
    accreditationStatusOptions.unshift({ value: '', text: '全部' });
    return {
      STATUS,
      statusOptions,
      accreditationStatusOptions,
      loading: false,
      error: false,
      finished: false,
      size: 30,
      current: 0,
      total: 1,
      pages: 1,
      hasNext: true,
      records: [],

      detail: {},
      detailShow: false,
      params: {
        accreditationStatus: '',
        keywords: '',
        regStartDate: '',
        regEndDate: '',
        status: '',
        improved: '',
        postedRequirements: '',
      },
      // 选择模式相关
      fromUserEdit: false,
      returnParams: {},

    };
  },
  methods: {
    selectMember(item = {}) {
      // miniMemberName 优先级: nickname > phoneNumber > wechatNo > memberId
      const miniMemberName = item.nickname || item.phoneNumber || item.wechatNo || item.memberId || '';
      const params = {
        ...this.returnParams,
        miniMemberId: item.memberId || '',
        miniMemberName,
      };
      const query = new URLSearchParams(params).toString();
      this.$router.replace(`/user/edit/bjs/${this.returnParams.userId || ''}?${query}`);
    },
    editItem(item = {}) {
      this.detail = { ...item };
      this.detailShow = true;
    },
    saveItem() {

    },
    deleteItem(item = {}) {
      this.$dialog.confirm({
        title: '确定',
        message: '确定拉黑当前用户吗？',
      }).then(() => {
        this.changeMemberStatus({
          status: STATUS.DELETE,
          memberId: item.memberId,
        });
      });
    },
    unbanItem(item = {}) {
      this.$dialog.confirm({
        title: '确定',
        message: '确定恢复当前用户吗？',
      }).then(() => {
        this.changeMemberStatus({
          status: STATUS.UNVERIFIED,
          memberId: item.memberId,
        });
      });
    },
    approveItem(item = {}) {
      this.$dialog.confirm({
        title: '确定',
        message: '确定审核通过吗？',
      }).then(() => {
        this.changeMemberAccreditationStatus({
          accreditationStatus: STATUS.APPROVED,
          memberId: item.memberId,
        });
      });
    },
    refuseItem(item = {}) {
      this.$dialog.confirm({
        title: '确定',
        message: '确定拒绝吗？',
      }).then(() => {
        this.changeMemberAccreditationStatus({
          accreditationStatus: STATUS.REFUSED,
          memberId: item.memberId,
        });
      });
    },
    changeMemberStatus(params = {}) {
      sendRequest(changeMemberStatus, params).then((res) => {
        this.getData();
        this.$dialog.alert({
          message: '操作成功',
        });
      }).catch((e) => {
        console.log(e);
        this.$dialog.alert({
          message: `${e.message}`,
        });
      }).then(() => {
        // this.$nextTick(() => {
        //   this.loading = false;
        // });
      });
    },
    changeMemberAccreditationStatus(params = {}) {
      sendRequest(changeMemberAccreditationStatus, params).then((res) => {
        this.getData();
        this.$dialog.alert({
          message: '操作成功',
        });
      }).catch((e) => {
        console.log(e);
        this.$dialog.alert({
          message: `${e.message}`,
        });
      }).then(() => {
        // this.$nextTick(() => {
        //   this.loading = false;
        // });
      });
    },
    exportData(e = {}) {
      this.$dialog.confirm({
        title: '确认',
        message: '确定立即下载用户信息吗？',
      }).then(() => {
        const token = storage.local.get('token') || '';
        const link = document.createElement('a');
        link.style.display = 'none';
        link.href = `${config.DOWNLOAD_DOMAIN}/api/connections/report?token=${token}`;
        // console.log(link.href);
        // 获取文件名
        // download 属性定义了下载链接的地址而不是跳转路径
        link.setAttribute('download', '用户圈子.xlsx');
        document.body.appendChild(link);
        link.click();
      }).catch(() => {
        // on cancel
      });
    },
    loadMore() {
      if (this.pages <= this.current) {
        return;
      }
      this.getData(this.current + 1);
    },
    getData(page = 1) {
      // console.log(this.loading);
      this.error = false;
      sendRequest(getConnectionsList, {
        current: page,
        size: this.size,
        ...this.params,
      }).then((res) => {
        const {
          total = 1, records = [], pages = 1, hasNext = false,
        } = res;
        // eslint-disable-next-line eqeqeq
        if (page == 1) {
          this.records = records || [];
        } else {
          this.records = this.records.concat(records || []);
        }
        this.total = total;
        this.pages = pages;
        this.hasNext = hasNext;
        this.current = page;
        if (!this.hasNext || (records || []).length < this.size || this.records.length >= this.total) {
          this.finished = true;
        } else {
          this.finished = false;
        }
      }).catch((e) => {
        console.log(e);
        this.$dialog.alert({
          message: `${e.message}`,
        });
        this.error = true;
      }).then(() => {
        this.$nextTick(() => {
          this.loading = false;
        });
      });
    },
    goDetail(e = {}) {
      storage.local.set('busername', e.username || '');
      if (e.id) {
        this.$router.push(`/user/edit/${e.type === 3 ? 'hzdw' : 'bjs'}/${e.id || ''}`);
      } else {
        this.$router.push('/user/home');
      }
    },
    goNotice(e = {}) {
      this.$router.push('/notice/info');
    },
    goData(url) {
      this.$router.push(url || '/data/info');
    },
    goSet(e = {}) {
      // storage.local.set('busername', e.username || '');
      this.$router.push(`/user/sync/rule/${e.id || ''}`);
    },
    back() {
      if (this.fromUserEdit) {
        const query = new URLSearchParams(this.returnParams).toString();
        this.$router.replace(`/user/edit/bjs/${this.returnParams.userId || ''}?${query}`);
      } else {
        // this.$router.back();
        this.$router.push('/home');
      }
    },
  },
  created() {
    const {
      fromUserEdit = false,
      userId = '',
      miniMemberId = '',
      miniMemberName = '',
      webStoreId = '',
      webStoreName = '',
      miniStoreId = '',
      miniStoreName = '',
    } = this.$route.query;

    this.fromUserEdit = fromUserEdit === 'true' || fromUserEdit === true;
    if (this.fromUserEdit) {
      this.returnParams = {
        userId,
        miniMemberId,
        miniMemberName,
        webStoreId,
        webStoreName,
        miniStoreId,
        miniStoreName,
      };
    }
  },
});
</script>
<style scoped>
  .MemberList {
    min-height: 100vh;
    background-color: #ffffff;
    font-size: 14px;
  }
  input, select {
    height: 26px;
    width: 105px;
    font-size: 14px;
    border: 1px solid #a7a9af;
    background-color: #ffffff;
    border-radius: 4px;
  }
  .keywords-input {
    width: 180px;
  }
  .date-select {
    width: 90px;
  }
  .button {
    min-width: 80px;
    height: 26px;
  }
</style>
